
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/knowledge/category/[slug]/page/[pageNo]",
      function () {
        return require("private-next-pages/knowledge/category/[slug]/page/[pageNo].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/knowledge/category/[slug]/page/[pageNo]"])
      });
    }
  